/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SingletonWhitelistPaymaster,
  SingletonWhitelistPaymasterInterface,
} from "../SingletonWhitelistPaymaster";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "destination",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "AdminOverrideWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "dappOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "useSenderWhitelist",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "useTargetWhitelist",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "useMethodWhitelist",
        type: "bool",
      },
    ],
    name: "DappConfigChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "dappOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "gasUseWithoutPost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalCharge",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paymasterCharge",
        type: "uint256",
      },
    ],
    name: "PostRelayedCall",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "dappOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    name: "Received",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "gasUsedByPost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paymasterFee",
        type: "uint256",
      },
    ],
    name: "SharedConfigChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "dappOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    name: "WhitelistedMethodsForTarget",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "dappOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    name: "WhitelistedSenders",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "dappOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    name: "WhitelistedTargets",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "dappOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [],
    name: "CALLDATA_SIZE_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FORWARDER_HUB_OVERHEAD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAYMASTER_ACCEPTANCE_BUDGET",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "POST_RELAYED_CALL_GAS_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRE_RELAYED_CALL_GAS_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gasUsedByPost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getGasAndDataLimits",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "acceptanceBudget",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preRelayedCallGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "postRelayedCallGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "calldataSizeLimit",
            type: "uint256",
          },
        ],
        internalType: "struct IPaymaster.GasAndDataLimits",
        name: "limits",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRelayHub",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTrustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paymasterFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "context",
        type: "bytes",
      },
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "gasUseWithoutPost",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "transactionCalldataGasUsed",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "relayWorker",
            type: "address",
          },
          {
            internalType: "address",
            name: "paymaster",
            type: "address",
          },
          {
            internalType: "address",
            name: "forwarder",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "paymasterData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "clientId",
            type: "uint256",
          },
        ],
        internalType: "struct GsnTypes.RelayData",
        name: "relayData",
        type: "tuple",
      },
    ],
    name: "postRelayedCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "gas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "data",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "validUntilTime",
                type: "uint256",
              },
            ],
            internalType: "struct IForwarder.ForwardRequest",
            name: "request",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxPriorityFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "transactionCalldataGasUsed",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "relayWorker",
                type: "address",
              },
              {
                internalType: "address",
                name: "paymaster",
                type: "address",
              },
              {
                internalType: "address",
                name: "forwarder",
                type: "address",
              },
              {
                internalType: "bytes",
                name: "paymasterData",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "clientId",
                type: "uint256",
              },
            ],
            internalType: "struct GsnTypes.RelayData",
            name: "relayData",
            type: "tuple",
          },
        ],
        internalType: "struct GsnTypes.RelayRequest",
        name: "relayRequest",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "approvalData",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "maxPossibleGas",
        type: "uint256",
      },
    ],
    name: "preRelayedCall",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "registeredDapps",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "useSenderWhitelist",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "useTargetWhitelist",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "useMethodWhitelist",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IRelayHub",
        name: "hub",
        type: "address",
      },
    ],
    name: "setRelayHub",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "setTrustedForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "target",
        type: "address",
      },
    ],
    name: "withdrawRelayHubDepositTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
  {
    inputs: [],
    name: "versionPaymaster",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "senders",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "isAllowed",
        type: "bool",
      },
    ],
    name: "whitelistSenders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "targets",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "isAllowed",
        type: "bool",
      },
    ],
    name: "whitelistTargets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes4[]",
        name: "methods",
        type: "bytes4[]",
      },
      {
        internalType: "bool",
        name: "isAllowed",
        type: "bool",
      },
    ],
    name: "whitelistMethodsForTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_gasUsedByPost",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_paymasterFee",
        type: "uint256",
      },
    ],
    name: "setSharedConfiguration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_useSenderWhitelist",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "_useTargetWhitelist",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "_useMethodWhitelist",
        type: "bool",
      },
    ],
    name: "setDappConfiguration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dappOwner",
        type: "address",
      },
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "isSenderWhitelistedForDappOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dappOwner",
        type: "address",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "isTargetWhitelistedForDappOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dappOwner",
        type: "address",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "method",
        type: "bytes4",
      },
    ],
    name: "isMethodWhitelistedForTargetAndDappOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "charge",
        type: "uint256",
      },
    ],
    name: "addPaymasterFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "destination",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "adminOverrideWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type SingletonWhitelistPaymasterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SingletonWhitelistPaymasterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SingletonWhitelistPaymaster__factory extends ContractFactory {
  constructor(...args: SingletonWhitelistPaymasterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<SingletonWhitelistPaymaster> {
    return super.deploy(
      overrides || {}
    ) as Promise<SingletonWhitelistPaymaster>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): SingletonWhitelistPaymaster {
    return super.attach(address) as SingletonWhitelistPaymaster;
  }
  override connect(signer: Signer): SingletonWhitelistPaymaster__factory {
    return super.connect(signer) as SingletonWhitelistPaymaster__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SingletonWhitelistPaymasterInterface {
    return new utils.Interface(_abi) as SingletonWhitelistPaymasterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SingletonWhitelistPaymaster {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as SingletonWhitelistPaymaster;
  }
}
